import Glide from '@glidejs/glide';

let glide = new Glide('.glide', {
  type: 'carousel',
  perView: 2,
  focusAt: 'center',
  gap: 24,
  breakpoints: {
    900: {
      perView: 1,
      peek: 0,
    },
  },
});
glide.mount();
